class ViewHelpers {

  /* Theme Colors */
  static get COLOR_THEME_GRAY() {return '#939393'};
  static get COLOR_THEME_LIGHT_GRAY() {return '#E3E3E3'};
  static get COLOR_THEME_DARK_GRAY() {return '#3A3D41'};
  static get COLOR_THEME_EXTRA_DARK_GRAY() {return '#1D1F21'};
  static get COLOR_THEME_SKY_BLUE() {return '#05AFD6'};
  static get COLOR_THEME_OLIVE() {return '#9A9221'};
  static get COLOR_THEME_OFF_WHITE() {return '#EFF2F2'};
}

export default ViewHelpers;



// WEBPACK FOOTER //
// ./src/utils/viewHelpers.js